<template>
    <div class="prodDisplay">
        <div class="display_pic">
            <img v-if="imgUrl" style="width: 80px;height: 80px;" :src="imgUrl" alt="">
        </div>
        <div class="display_content content">{{title}}</div>
        <div class="display_content button">
            <el-button type="primary" size="small" @click="query">查看产品页</el-button>
            <el-button type="primary" size="small" @click="select">google搜索</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ['imgUrl', 'title', 'domain'],
    methods: {
        query(){
            window.open(this.domain)
        },
        select() {
            window.open(`https://www.google.com/search?q=${this.title}`, "_blank")
        }
    }
}
</script>

<style lang="scss" scoped>
.prodDisplay {
    height: 118px;
    box-shadow: 0px 1px 6px 0px rgba(51, 51, 51, 0.1);
    border-radius: 4px;
    position: relative;
    margin-bottom: 20px;
    .display_pic {
        position: absolute;
        top: 50%;
        margin: -40px 0 -40px 10px;
        width: 80px;
        height: 80px;
        border-radius: 2px;
    }

    .display_content {
        position: absolute;
        top: 50%;
        width: 240px;
        height: 40px;
        border-radius: 2px;
        // background-color: rgb(128, 0, 60);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
    }

    .content {
        margin: -40px 0 -40px 100px;
    }

    .button {
        margin: 15px 0 -40px 100px;
    }
}
</style>